import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

const DataExport: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Data Export — Sprout Docs</title>
        <meta
          name="description"
          content="How to export your data from Sprout. Available on every plan in JSON, CSV, and PDF formats. Supports POPIA Section 23 right of access."
        />
        <link rel="canonical" href="https://sprout-ui-pi.vercel.app/docs/security/data-export" />
      </Helmet>

      <h1>Data Export</h1>
      <p className="lead">
        Your school's data belongs to you. Sprout supports per-child data
        export on every plan, including the free Seedling tier — there is no
        "export gate" behind an upgrade.
      </p>

      <h2>What you can export today</h2>
      <p>
        A full-fidelity JSON dump of a single child's record: their profile,
        every observation, every assessment, recorded consents, and audit
        metadata describing who exported the data and why.
      </p>

      <h2>How to run an export</h2>
      <ol>
        <li>Open <strong>Settings</strong> from the sidebar.</li>
        <li>Scroll to <strong>Data Export</strong>.</li>
        <li>Pick a child from the dropdown and click <strong>Download JSON</strong>. The file is generated in-browser and saved to your device immediately.</li>
      </ol>

      <h2>What's included</h2>
      <p>
        The JSON contains the full set of observations, assessments, and
        consent records linked to the selected child, along with the staff
        member who triggered the export. Photos and videos attached to
        observations are referenced by signed URL inside the JSON — you can
        download each one individually from the same record.
      </p>

      <h2>POPIA Section 23 — Right of Access</h2>
      <p>
        POPIA gives data subjects the right to access the personal
        information held about them. For minors, that right is exercised by
        a guardian. The per-child export is how Sprout supports this: a
        school admin can produce a JSON export for any individual child and
        share it with their guardian on request.
      </p>

      <h2>What's coming</h2>
      <p>
        Bulk export (whole organisation or a classroom) and additional
        formats (CSV, PDF) are on the roadmap. If you need a larger or
        formatted export today, <Link to="/contact">get in touch</Link> and
        we can produce one for you.
      </p>

      <p>
        See <Link to="/docs/security/popia">POPIA Compliance</Link> for the
        wider compliance picture.
      </p>
    </>
  );
};

export default DataExport;
